/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { DriverVoModel } from '@well/delivery-libs/driver-management/domain';

export class ShipmentDriverDtoModel extends JSONable {
  uuid: string | null = null;
  owner: string | null = null;
  driverName: string | null = null;
  driverPhone: string | null = null;
  driverVO: DriverVoModel | null = null;
  shipmentBaseUuid: string | null = null;
}
